import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import { Image } from '@bd/bdcore-utilities';
import { BtnAnimationSheen } from '../../helpers/UIElements';

import AccordionToggle from '../../components/AccordionToggle';
import icons from '../../components/IconsList';
import { colors } from '../../styles';

const styles = css`
  @media(min-width: 992px) {
    padding: 50px 20px;
  }
  .FloorplanPhotos_image {
    cursor: pointer;
  }
  .HomeFloorPlans_btn {
    width: 200px;
    &:focus {
      outline: none;
    }
  }
  .DetailSection_heading {
    border-top: 1px solid #E3E3E3;
    @media(min-width: 992px) {
      border-top: 0;
    }
  }

  .FloorplanPhotos_overlay {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 144, 210, 0.85);
    width: 100%;
    height: 100%;
    display: none;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all .3s ease-out;
    &::after {
      content: '';
      background-image: url(${get(icons, 'expendWhite')});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 26px;
      height: 26px;
      @media(min-width: 992px) {
        width: 45px;
        height: 45px;
      }
    }
  }
  .HomePhotos_img {
    z-index: 2;
    &:hover {
      .FloorplanPhotos_overlay {
        display: flex;
      }
    }
  }

  .FloorplanPhotos_btnsWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .FloorplanPhotos_btns {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background-size: 30px 30px;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 3;
    @media(min-width: 992px) {
      width: 45px;
      height: 45px;
      background-size: 45px 45px;
    }
    &:focus {
      outline: none;
    }
  }
  .next {
    right: 0;
    background-image: url('/images/icons/carousel-right-detail-light.svg');
    @media(min-width: 992px) {
      right: 5%;
    }
  }

  .prev {
    left: 0;
    background-image: url('/images/icons/carousel-left-detail-light.svg');
    @media(min-width: 992px) {
      left: 5%;
    }
  }

  .HomeFloorPlans_btn {
    width: 290px;
    margin: 0 auto 50px;
    @media(min-width: 992px) {
      width: 350px;
    }
  }
  .HomeFloorPlans_btnHref {
    height: 45px;
    color: #FFF;
    text-transform: uppercase;
    font-size: 14px;
    display: flex;
    align-items: center;
    @media(min-width: 992px) {
      font-size: 15px;
      height: 55px;
    }
    &:hover {
      color: ${colors.whiteDarker};
    }
  }
`;


class HomeFloorPlans extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  next = () => {
    if (!this.state.hover) {
      const { index } = this.state;
      const { home } = this.props;
      const nextIndex = (index + 1 >= get(home, 'floorplanPhotos').length) ? 0 : index + 1;
      this.setState({
        index: nextIndex,
      });
    }
  }
  prev = () => {
    if (!this.state.hover) {
      const { index } = this.state;
      const { home } = this.props;
      const nextIndex = (index === 0) ? get(home, 'floorplanPhotos').length - 1 : index - 1;
      this.setState({
        index: nextIndex,
      });
    }
  }
  render() {
    const { index } = this.state;
    const { home } = this.props;

    const currentImage = get(home, 'floorplanPhotos')[index];
    return (
      <div className={styles}>
        <AccordionToggle
          openOnId="floorplans"
          button={({ contentVisible }) => (
            <div className="">
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Floor Plan</h3>
            </div>
          )}
        >
          <div className="container">
            <div className="d-flex flex-wrap justify-content-center position-relative">
              <LightBox
                items={get(home, 'floorplanPhotos')}
                className="col-10 col-lg-8 mb-5 HomePhotos_img"
                button={(
                  <div className="position-relative">
                    <Image
                      src={get(currentImage, 'contentUrl')}
                      alt={get(currentImage, 'caption', '')}
                      width={2000}
                      height={2000}
                      className=" img-fluid FloorplanPhotos_image"
                    />
                  </div>
                )}
              />
              <div className="FloorplanPhotos_btnsWrapper col-10 col-lg-8">
                {
                  index > 0 &&
                  <span role="button" tabIndex={0} onClick={this.prev} className="FloorplanPhotos_btns prev" />
                }
                {
                  index < (get(home, 'floorplanPhotos').length - 1) &&
                  <span role="button" tabIndex={0} onClick={this.next} className="FloorplanPhotos_btns next" />
                }
              </div>
            </div>
            <BtnAnimationSheen className="Btn_default HomeFloorPlans_btn">
              <a href={get(currentImage, 'contentUrl')} target="_blank" rel="noopener noreferrer" className="HomeFloorPlans_btnHref">Print/Download FloorPlan</a>
            </BtnAnimationSheen>
          </div>
        </AccordionToggle>
      </div>
    );
  }
}

HomeFloorPlans.propTypes = {
  home: PropTypes.object.isRequired,
};

export default HomeFloorPlans;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeFloorplans.js